export const stepEnum = {
  asnSearch: 0,
  asnSummary: 1,
  receiveLpn: 2,
  moreOptions: 3,
  revertReceivedLpn: 4,
  asnSelection: 5,
  asnUnkown: 6
}

export const filterEnum = {
  lpn: 1,
  sku: 2,
  supplier: 3,
  supplierOrigin: 4
}
